<script lang="ts">
	// Svelte hooks
	import { onMount } from 'svelte';
	// Stores
	import { home_data } from 'src/stores/account/user';
	// Services
	import { format } from 'svelte-i18n';
	// Helpers
	import { getImages } from '../../Lists/list-helpers';
	import { save_home } from '../../../helpers/home_helpers';
	import { getAppBackgroundSrc } from '../../../helpers/account_helpers';
	import { getFormatedValue } from '@Shelly/shelly-design-system/TimePicker/time-picker-helpers';
	// Components
	import ImageList from '../../Lists/ImageListV2.svelte';

	const requestType = 'home_background';

	const imagesByTypeDB = Array.from({ length: 10 }, (_, i) => {
		const value = getFormatedValue(i + 1);
		return {
			local: true,
			filepath: `images/home_def/app_bg_${value}.png`,
			thumb: `images/home_def/app_bg_${value}_thumb.png`,
		};
	});

	let uploadedImagesDB = [
		{
			local: false,
		},
	];

	// Image List Functions
	const onSelectImage = (e: CustomEvent) => {
		const homeDataLayout = $home_data.layout || {};

		if (e.detail.backgroundColor) {
			// Save color and clear image
			save_home('layout', {
				backgroundColor: e.detail.backgroundColor,
				appBackgroud: '',
			});

			home_data.set({
				...$home_data,
				layout: {
					...homeDataLayout,
					backgroundColor: e.detail.backgroundColor,
					appBackgroud: '',
				},
			});
		} else if (e.detail.image) {
			// Save image and clear color
			save_home('layout', {
				appBackgroud: e.detail.image,
				backgroundColor: '',
			});

			home_data.set({
				...$home_data,
				layout: {
					...homeDataLayout,
					appBackgroud: e.detail.image,
					backgroundColor: '',
				},
			});
		}
	};

	const onUploadImage = (e: CustomEvent) => {
		onSelectImage(e);
	};

	const onDeleteImage = (e: CustomEvent) => {
		onSelectImage(e);
	};

	const updateHomeData = (appBackgroudSrc: string) => {
		const homeDataLayout = $home_data.layout || {};

		// SAVE HOME SETTINGS
		save_home('layout', {
			appBackgroud: appBackgroudSrc,
		});

		home_data.set({
			...$home_data,
			layout: {
				...homeDataLayout,
				appBackgroud: appBackgroudSrc,
			},
		});
	};

	onMount(async () => {
		uploadedImagesDB = await getImages(requestType);
	});
</script>

<ImageList
	groupTitle={{
		upload: $format('image_list_title_picture_custom', {
			default: 'Custom Picture',
		}),
		type: $format('gallery_bg_title', { default: 'Gallery Backgrounds' }),
	}}
	{requestType}
	{uploadedImagesDB}
	{imagesByTypeDB}
	selectedImage={getAppBackgroundSrc($home_data)}
	selectedBackgroundColor={$home_data?.layout?.backgroundColor || ''}
	showColors={true}
	on:select-image={onSelectImage}
	on:upload-image={onUploadImage}
	on:delete-image={onDeleteImage}
	uploadSettings={{
		single: true,
		imageUploadSettings: {
			type: 'button',
			useV2Components: true,
			btnSettings: {
				title:
					uploadedImagesDB.length === 0
						? $format('upload_image_title', { default: 'Upload Image' })
						: $format('change_image_title', { default: 'Change Image' }),
				variant: uploadedImagesDB.length === 0 ? 'primary' : 'secondary',
			},
		},
	}}
	uploadImageAlert={{
		type: 'info',
		heading: $format('image_alert', {
			default: 'Recommended dimension is 1440 by 1440 pixels, size limit 2000 kb max.',
		}),
	}}
	defaultType="edit"
	imgGroupType="preview"
/>
<!-- remove key bg_img_info_msg -->
